"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/TranslationPill.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _translation = require('shared/actions/translation');
var _translation3 = require('shared/selectors/translation');
var _hooks = require('web/services/hooks');
var _noticeBar = require('web/services/context/noticeBar');
var _TranslationIcon = require('./TranslationIcon'); var _TranslationIcon2 = _interopRequireDefault(_TranslationIcon);






/* "Not English · Translate?" (or "Spanish? Translate" when the server
 * names the language) under the patient message the server picked. The
 * whole lead is one button: it has the server translate that message only,
 * the same as Translate in the message's menu, which then asks whether to
 * set the patient's language (LanguageOfferDialog). It's English dismisses the pill for this
 * message (it comes back only for a later message clearly not in English),
 * and ✕ hides it for this chat until the app is reloaded (nothing is
 * sent). */
const TranslationPill = ({ conversationKey, messageKey }) => {
  const [isRunning, setIsRunning] = _react.useState.call(void 0, false)
  const [isFailed, setIsFailed] = _react.useState.call(void 0, false)
  // A Translate from this chat's options menu is waiting too.
  const translating = _hooks.useAppSelector.call(void 0, state => _translation3.selectIsTranslatingFromMessage.call(void 0, state, conversationKey))
  const copy = _hooks.useAppSelector.call(void 0, state => _translation3.selectPillCopy.call(void 0, state, conversationKey))
  const isBusy = isRunning || translating
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const run = _react.useCallback.call(void 0, (command) => {
    setIsRunning(true)
    command()
      .catch(() => showWarningBar("Couldn't update translation. Try again."))
      .finally(() => setIsRunning(false))
  }, [showWarningBar])

  // Resolves to the notice to show (English, undetermined or failed), or
  // null once translation is on; it never rejects. A failure shows on the
  // pill itself.
  const onTranslate = _react.useCallback.call(void 0, () => run(() => {
    setIsFailed(false)
    return _actions2.default.translateFromMessage({
      ConversationKey: conversationKey,
      MessageKey: messageKey,
    }).then((notice) => {
      if (notice === _translation.TRANSLATE_FROM_MESSAGE_NOTICES.failed) setIsFailed(true)
      else if (notice) showWarningBar(notice)
    })
  }), [run, conversationKey, messageKey, showWarningBar])

  const onEnglish = _react.useCallback.call(void 0, () => run(() => _actions2.default.markMessageEnglish({
    ConversationKey: conversationKey,
    MessageKey: messageKey,
  })), [run, conversationKey, messageKey])

  const onDismiss = _react.useCallback.call(void 0, 
    () => _actions2.default.dismissTranslationPill({ ConversationKey: conversationKey }),
    [conversationKey],
  )

  let lead = copy.lead
  let action = copy.action
  if (translating) {
    action = 'Translating…'
  } else if (isFailed) {
    lead = 'Translation unavailable ·'
    action = 'Try again'
  }

  return (
    _react2.default.createElement('div', { className: "translation-pill", role: "group", 'aria-label': "Translation", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
      , _react2.default.createElement('button', {
        type: "button",
        className: "translation-pill--main",
        'aria-label': copy.accessibilityLabel,
        'aria-busy': translating,
        disabled: isBusy,
        onClick: onTranslate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}

        , _react2.default.createElement(_TranslationIcon2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 84}} )
        , _react2.default.createElement('span', { className: "translation-pill--lead", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, lead)
        , _react2.default.createElement('span', { className: "translation-pill--action", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, action)
      )
      , _react2.default.createElement('button', {
        type: "button",
        className: "translation-pill--secondary",
        disabled: isBusy,
        onClick: onEnglish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
, "It's English"

      )
      , _react2.default.createElement('button', {
        type: "button",
        className: "translation-pill--dismiss",
        'aria-label': "Dismiss",
        disabled: isBusy,
        onClick: onDismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
, "✕"

      )
    )
  )
}

exports. default = _react.memo.call(void 0, TranslationPill)
